var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-table-item-value-date-container"},[(_vm.dateDisplayValue != null)?_c('div',{staticClass:"value-area"},[_vm._v(_vm._s(_vm.dateDisplayValue))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }